import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ListRecommendations } from "../../schema/icp";
import { recommendedListBullets } from "./recommendedListBullets";

/** The generic pitch — shown when the recommendation could not be loaded in time. */
const GenericIdeas: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<>
			{t("onboarding.chat.bothIntro")}
			<ul className="mt-2 list-disc space-y-1 pl-4">
				<li>{t("onboarding.chat.bothBullet1")}</li>
				<li>{t("onboarding.chat.bothBullet2")}</li>
				<li>{t("onboarding.chat.bothBullet3")}</li>
				<li>{t("onboarding.chat.bothBullet4")}</li>
			</ul>
		</>
	);
};

/**
 * The chat's hand-over message before the lists step: instead of generic ideas
 * it previews the two lists the picker is about to recommend, phrased with the
 * user's own targeting values, plus the tracking step that follows.
 */
export const RecommendedListsMessage: FunctionComponent<{
	recommendations: ListRecommendations | null;
}> = ({ recommendations }) => {
	const { t } = useTranslation();
	const bullets = recommendations ? recommendedListBullets(recommendations) : [];

	if (bullets.length === 0) {
		return <GenericIdeas />;
	}

	return (
		<>
			{t("onboarding.chat.bothIntroPersonal")}
			<ul className="mt-2 list-disc space-y-1 pl-4">
				{bullets.map((bullet) => (
					<li key={bullet.key}>{t(bullet.i18nKey, bullet.values)}</li>
				))}
				<li>{t("onboarding.chat.bothTrackLine")}</li>
			</ul>
		</>
	);
};
